<template>
  <picker
    :id="id"
    :label="id"
    :text="value"
    :skeleton="skeleton"
    class="picker--image"
  >
    <div
      v-if="skeleton"
      class="picker__elements d-flex flex-wrap justify-center"
    >
      <div
        v-for="(element, index) in elements"
        :key="index"
        class="picker__element d-flex flex-wrap align-center"
      >
        <picker-item :name="id" :value="`${index}`" skeleton />
      </div>
    </div>
    <div v-else class="picker__elements d-flex flex-wrap justify-center">
      <div
        v-for="element in elements"
        :key="element.value"
        class="picker__element d-flex flex-wrap align-center"
      >
        <picker-item
          :name="id"
          :value="element.value"
          :label="element.label ? element.label : undefined"
          :active="value === element.value"
          :image="getPickerImageUrl(element)"
          @input="selectElement(element)"
        />
      </div>
    </div>
  </picker>
</template>

<script>
import Picker from '@/components/picker/Picker'
import PickerItem from '@/components/picker/PickerItem'
import { PICKER_IMAGE_FORMAT } from '~/const/image'
import { getSanityBunnyImageLink } from '~/utils/image'

export default {
  name: 'ImagePicker',
  components: {
    Picker,
    PickerItem,
  },
  props: {
    value: { type: String, required: true },
    /**
     * Liste des elements
     */
    elements: {
      type: Array,
      required: true,
    },
    /**
     * identifiant du color picker
     */
    id: {
      type: String,
      required: true,
    },
    /**
     * Le composant est affiché en squelette de chargement
     */
    skeleton: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    selectElement(element) {
      this.$emit('input', element.value)
    },
    getPickerImageUrl(element) {
      return element.image
        ? {
            url: getSanityBunnyImageLink(element.image, PICKER_IMAGE_FORMAT),
            dimensions: PICKER_IMAGE_FORMAT,
          }
        : undefined
    },
  },
}
</script>

<style lang="scss">
.picker.picker--image {
  .picker__elements {
    margin: 0 calc(var(--spacing) * -1);
  }

  .picker-item {
    padding: 0 calc(var(--spacing));
    margin: 0;
  }
}
</style>
